export const FORMS_TITLE = {
	pt: "Para começar, insira os seus dados",
	es: "Para empezar, ingrese su información",
	en: "To get started, enter your information",
};